import { createContext, useCallback, useContext, useMemo, useState } from 'react';

export const CATALOG_TYPES = [
  {
    id: 'lights_living',
    label: 'Lights & Living',
    description: 'Lighting, furniture, appliances, outdoor and home finishing.'
  },
  {
    id: 'heavy_machine',
    label: 'Machinery & Equipment',
    description: 'Tools, machines, equipment and heavy duty project supplies.'
  }
];

const CATALOG_TYPE_STORAGE_KEY = 'bds_catalog_type';
const CatalogTypeContext = createContext(null);

const isValidCatalogType = (type) => CATALOG_TYPES.some((item) => item.id === type);

const getInitialCatalogType = () => {
  if (typeof window === 'undefined') return null;
  const stored = window.sessionStorage.getItem(CATALOG_TYPE_STORAGE_KEY);
  return isValidCatalogType(stored) ? stored : null;
};

export function CatalogTypeProvider({ children }) {
  const [catalogType, setCatalogTypeState] = useState(getInitialCatalogType);

  const setCatalogType = useCallback((type) => {
    if (!isValidCatalogType(type)) return;
    window.sessionStorage.setItem(CATALOG_TYPE_STORAGE_KEY, type);
    setCatalogTypeState(type);
  }, []);

  const currentCatalog = useMemo(
    () => CATALOG_TYPES.find((item) => item.id === catalogType) || null,
    [catalogType]
  );

  const value = useMemo(() => ({
    catalogType,
    currentCatalog,
    setCatalogType,
    hasCatalogType: Boolean(catalogType)
  }), [catalogType, currentCatalog, setCatalogType]);

  return (
    <CatalogTypeContext.Provider value={value}>
      {children}
    </CatalogTypeContext.Provider>
  );
}

export function useCatalogType() {
  const context = useContext(CatalogTypeContext);
  if (!context) {
    throw new Error('useCatalogType must be used within CatalogTypeProvider');
  }
  return context;
}
